import utils from "../../common/utils";
export default {
    submitLogin() {
        this.popGai2_show = !this.verification();
        if (!this.popGai2_show) {
            // 接口验证用户名和密码
            this.loginStaText = '登录中';
            const loginInterval = setInterval(() => {
                this.loginStaText = '.' + this.loginStaText + '.';
            }, 700);
            this.$api.loginApi(this.userInfo.userName, this.userInfo.passWord).then((res) => {
                clearInterval(loginInterval);
                if (res.status === 200) {
                    localStorage.setItem('aword', utils.encrypt(this.userInfo.userName));
                    localStorage.setItem('bword', utils.encrypt(this.userInfo.passWord));
                    if (+res.data.code === 200) {
                        // 本地化登录信息
                        this.$store.commit('SET_LOGIN', {
                            rememberMe: this.rememberMe,
                            user: res.data.data
                        });
                        this.$router.replace({path: '/'});
                    } else {
                        this.verificationText = res.data.msg;
                        this.popGai2_show = true;
                        this.loginStaText = '登录失败'
                    }
                }
            }).catch(e => {
                clearInterval(loginInterval);
                this.verificationText = '网络异常，请稍后重试';
                this.popGai2_show = true;
                this.loginStaText = '网络异常，请稍后重试'
            });

        }
    },
    verification() {
        this.verificationText = this.userInfo.userName === '' ? '用户名为空' : (this.userInfo.passWord === '' ? '密码为空' : this.userInfo.loginCode !== this.identifyCode ? '验证码错误' : '');
        return this.userInfo.userName !== '' &&
            this.userInfo.passWord !== '' &&
            this.userInfo.loginCode === this.identifyCode;
    }
}
